import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import 'App.scss';
import { RouterProvider } from 'react-router-dom';
import { router } from 'navigation/routes.js';
import InitialLoadingScreen from 'utils/customLayouts/mainLayouts/initialLoadingScreen/initialLoadingScreen';
import 'assets/font-awesome-4.7.0/css/font-awesome.min.css';
import { getLocalStorageItem } from 'services/others/storageServices';
import io from 'socket.io-client';
import { GlobalContext } from 'constants/globalContext';
import { eventFactory } from 'services/api/event.factory';
import { useDispatch, useSelector } from 'react-redux';
import { addUserData } from 'redux/reducer/userReducer';

function App() {
  const [isInitialization, setIsInitialization] = useState(true);
  const socketURL = process.env.REACT_APP_GATEWAYSERVICE_URL;
  const currentUserFromLocalStorage = getLocalStorageItem('currentUser');
  const dispatch = useDispatch();
  const currentUserFromRedux = useSelector((state) => state?.user?.userData);
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    const socketInstance = io(socketURL, {
      auth: (cb) => cb({ token: getLocalStorageItem('konstru_token') || '' }),
      transports: ['websocket', 'polling'],
      reconnection: true,
      reconnectionAttempts: 50,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 10000,
      timeout: 30000,
      extraHeaders: {
        'X-App-Name': 'konstru-web'
      }
    });
    setSocket(socketInstance);

    const loadingScreen = async () => {
      await new Promise((resolve) => setTimeout(resolve, 2000));
      setIsInitialization(false);
    };
    loadingScreen();

    // reconnect lifecycle events fire on the Manager in socket.io v4, not the
    // socket, so register them once here; the socket-level events ('connect',
    // 'disconnect', 'connect_error') live in event.factory.js
    socketInstance.io.on('reconnect', (attemptNumber) => {
      console.log(
        'Gateway socket reconnected after',
        attemptNumber,
        'attempts'
      );
    });
    socketInstance.io.on('reconnect_error', (error) => {
      console.error('Gateway socket reconnect_error:', error.message);
    });
    socketInstance.io.on('reconnect_failed', () => {
      console.error('Gateway socket reconnect failed - giving up');
    });

    // joining the user's room is handled by the 'connect' handler in
    // event.factory.js, which fires on the initial connection and every
    // reconnect — do not emit 'login' here as well
    if (currentUserFromLocalStorage) {
      dispatch(addUserData(currentUserFromLocalStorage));
    }

    // clean up function for socket
    return () => {
      socketInstance.disconnect();
    };
  }, []);

  useEffect(() => {
    if (!socket) {
      console.warn('Socket is not initialized yet.');
      return;
    }

    if (currentUserFromRedux?._id || currentUserFromLocalStorage) {
      socket.removeAllListeners(); // prevent listener accumulation on re-runs
      eventFactory(socket);
    }
    // depend on stable ids: the parsed localStorage object is a fresh
    // reference every render and would re-run this effect constantly
  }, [socket, currentUserFromRedux?._id, currentUserFromLocalStorage?._id]);

  return (
    <div className="main">
      {isInitialization ? (
        <InitialLoadingScreen />
      ) : (
        <>
          <GlobalContext.Provider
            value={{
              socket
            }}
          >
            <RouterProvider router={router} />
          </GlobalContext.Provider>
        </>
      )}
    </div>
  );
}

export default App;
